export default __webpack_public_path__ + "static/media/GurbaniLipi.ec082737.ttf";